"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGeneralLineageLabelsLazyQuery = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const react_1 = tslib_1.__importDefault(require("react"));
const lazyQueryHelper_1 = require("./lazyQueryHelper");
function useGeneralLineageLabelsLazyQuery({ item, controls, includeParented, includeUpstream, document }) {
    const [fire, { loading, error, data }] = (0, client_1.useLazyQuery)(document);
    const invoke = react_1.default.useCallback(() => {
        var _a, _b;
        void fire({ variables: { luid: (_a = item.contentLuid) !== null && _a !== void 0 ? _a : null, id: (_b = item.contentId) !== null && _b !== void 0 ? _b : null } });
    }, [fire, item]);
    const upstreamLabels = (data === null || data === void 0 ? void 0 : data.items[0]) ? data === null || data === void 0 ? void 0 : data.items[0].upstreamLabels : undefined;
    const result = Object.assign({ loading,
        error }, (0, lazyQueryHelper_1.convertLabelsFragmentIntoRenderProps)({ upstreamLabels, item, controls, includeParented, includeUpstream }));
    return [invoke, result];
}
exports.useGeneralLineageLabelsLazyQuery = useGeneralLineageLabelsLazyQuery;
//# sourceMappingURL=useGeneralLineageLabelsLazyQuery.js.map